import styled from 'styled-components';
import { Col } from 'react-bootstrap';
import ArrowDownIcon from 'components/ArrowDownIcon';
import { NavLink } from 'react-router-dom';

export const ShopItemsContainer = styled.div`
    width: 100%;
    height: 100%;
    padding: 100px 0px 0px 0px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;

export const ContainerDetail = styled.div`
    max-width: 600px;
`;

export const ContainerReturn = styled(NavLink)`
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 130%;
    display: flex;
    align-items: center;
    justify-content:flex-end;
    width: fit-content;
    letter-spacing: 0.02em;
    font-feature-settings: 'ordn' on, 'cpsp' on;
    color: #D6E1EF;
    text-shadow: -1px -1px 2px rgba(255, 255, 255, 0.1), 1px 1px 3px #1E2226;
    margin-left: auto;
    cursor: pointer;
    opacity: 0.7;
    &:hover{
        font-feature-settings: 'ordn' on, 'cpsp' on;
        color: #D6E1EF;
        text-shadow: -1px -1px 2px rgba(255, 255, 255, 0.1), 1px 1px 3px #1E2226;
        opacity: 0.9;
        &>svg{
            opacity: 0.9;
        }
    }
    &>svg{
        display: flex;
        align-items: center;
        justify-content: center;
        transform: rotate(90deg);
        margin-bottom: 5px;
        width: 10px;
        margin-right: 4px;
        opacity: 0.7;
    }
`;

export const RelatedServicesLabel =styled.div`
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 130%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-left: 10px;
    width: 100%;
    letter-spacing: 0.02em;
    font-feature-settings: 'ordn' on, 'cpsp' on;
    color: #D6E1EF;
    text-shadow: -1px -1px 2px rgba(255, 255, 255, 0.1), 1px 1px 3px #1E2226;
    margin-right: auto;
    opacity:0.8;
`;


export const StyledArrowDownIcon = styled(ArrowDownIcon)`
    transform: rotate(90deg);
`;

export const ContainerRelatedElements = styled(Col)`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
`;

export const ContainerBreadcrumbs = styled.div`
    width: 100%;
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    line-height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    text-decoration-line: underline;
    color: #D6E1EF;
    opacity: 0.8;
    margin-bottom: 20px;
`;

export const ContainerLoader = styled.div`
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
`;